import React from "react";

import { Button } from "../../../shared/Button/Button";
import { Icon } from "../../../shared/Icon/Icon";

import "./InsightsReportCancelled.scss";

interface Props {
  onRunAgain: () => void;
}

export const InsightsReportCancelled = ({ onRunAgain }: Props) => {
  return (
    <div className="InsightsReportCancelled">
      <h3 className="InsightsReportCancelled__title">
        Insights report generation was cancelled
      </h3>
      <p className="InsightsReportCancelled__subtitle">
        You cancelled the report before processing completed.
      </p>

      <Icon
        className="InsightsReportCancelled__icon"
        icon="pause-icon"
      />

      <p className="InsightsReportCancelled__helper">
        Navigate to another section or generate a new report
      </p>

      <Button
        className="InsightsReportCancelled__action"
        title="Run again"
        color="simple"
        size="small"
        onClick={onRunAgain}
      />
    </div>
  );
};
